import { Injectable } from '@angular/core';

import { ConfirmService } from '../ui.module/confirm.service';

export const confirmRespawnInnerHTML = `
    <p class='--text-left'>
        All your buildings and creeps will become unowned so that you
        can reset your spawn in any vacant room on the map.
        <a class='_link' href="http://docs.screeps.com/respawn.html" app-nw-external-link>Learn more</a>
    </p>
    <p class='--text-left'>
        <b>Note:</b> you will NOT be able to spawn again in the same
        room within 3 days since the initial spawn placement!
    </p>
`;

@Injectable()
export class ShowDlgWorldRespawnService {
    constructor(
        private _confirm: ConfirmService,
    ) {
    }

    show(): Promise<void> {
        return this._confirm.show({ data: {
            icon: 'app2/assets/order/attention-red.svg',
            iconWidth: 64,
            iconHeight: 64,
            title: '',
            innerHTML: confirmRespawnInnerHTML,
            buttonOkLabel: 'Respawn'
        }});
    }
}
